import React from 'react'
import PropTypes from 'prop-types'
import {renderProcessName, renderRoleName, renderStateName, renderTaskName} from '../../util/names'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import {formatDateTime} from '../../../../util/datetime'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import {Link} from 'react-router-dom'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import ContentBoxBody from '../../../layout/component/ContentBoxBody'
import ContentBoxHeader from '../../../layout/component/ContentBoxHeader'
import VipIcon from '../../../form/component/VipIcon'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import {ROLE_EMPLOYEE, ROLE_TASK_ADMIN} from '../../../security/state/auth/const'
import DatePicker from '../../../form/component/DatePicker'
import HasNotAuthorization from '../../../security/component/auth/HasNotAuthorizationContainer'
import Select from '../../../form/component/Select'
import {renderStoreName} from '../../../store/util/renderStoreName'
import TaskResponsible from './TaskResponsible'
import ProcessFlow from './ProcessFlow'
import ToggleProcessFlowButton from './ToggleProcessFlowButton'
import TransitionList from './TransitionList'
import ChangeTaskResponsible from './ChangeTaskResponsible'
import currentUserHasAccess from '../../../../util/widget-helper'
import {OVERVIEW} from '../../ui-definition/process-ui'
import {
    ALLOWED_TASKS_FOR_APPOINTMENT_INFO,
    APPOINTMENT_REASON_LIST,
    APPOINTMENT_TYPE_LIST
} from "../../../appointment/state/const";

const STATUS_LIST = [
    {
        id: 'open',
        value: 'open',
    },
    {
        id: 'pending',
        value: 'pending',
    },
    {
        id: 'finished',
        value: 'finished',
    },
]

const   TaskOverviewWidget = ({
                                treatmentPlan,
                                isPartner,
                                claimTask,
                                userWithRoleForTask,
                                updateAssignedToUserId,
                                changeAssignedTo,
                                unClaimTask,
                                isTaskAdmin,
                                taskReadOnly,
                                processFlowVisible,
                                changeTaskDueDate,
                                changeTaskStatus,
                                toggleProcessFlowVisibility,
                                validateAndTriggerEvent,
                                currentState,
                                task,
                                taskName,
                                role,
                                userId,
                                assignedToUser,
                                availableTransitionList,
                                validationMessageList,
                                onyxId,
                                onyxServer
                            }) => {
    if (!currentUserHasAccess(OVERVIEW)) {
        return null
    }

    const title = (isPartner) ? 'Task ' + renderTaskName(taskName) : 'Task ' + task.processDisplayName + ' ' + renderTaskName(taskName) + ' '
    const complexity = (treatmentPlan) ? 'Complexity ' + ((treatmentPlan.complexity) ? treatmentPlan.complexity : '') : ''

    const activeAppointment = getLatestAppointment(task.objectDetail.customer.appointmentList);
    const isAppointmentInfoVisible = ALLOWED_TASKS_FOR_APPOINTMENT_INFO.includes(taskName);

    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <h1><VipIcon
                    onClick={(() => {
                    })}
                    active={task.vip}/>&#160;
                    {title}
                </h1>
            </ContentBoxHeader>
            <ContentBoxBody>

                <Row>
                    <Column size={12}>
                        <ToggleProcessFlowButton
                            isPartner={isPartner}
                            toggleProcessFlowVisibility={toggleProcessFlowVisibility}
                            processFlowVisible={processFlowVisible}/>
                        <TransitionList
                            task={task}
                            taskReadOnly={taskReadOnly}
                            availableTransitionList={availableTransitionList}
                            validateAndTriggerEvent={validateAndTriggerEvent}/>
                    </Column>
                </Row>

                <Row top="M">
                    <Column size={12}>
                        <ValidationMessageList validationMessageList={validationMessageList}/>
                    </Column>
                </Row>

                <ProcessFlow processFlowVisible={processFlowVisible} processInstanceId={task.processInstanceId}/>

                <Row>
                    <Column size={4}>
                        <table className="process-info-table">
                            <tbody>
                            <tr>
                                <td>Status</td>
                                <td>
                                    <Authorization requiredRole={ROLE_TASK_ADMIN}>
                                        <Select object={task} name="status" valueList={STATUS_LIST}
                                                onChange={changeTaskStatus}/>
                                    </Authorization>

                                    <HasNotAuthorization requiredRole={ROLE_TASK_ADMIN}>
                                        {task.status}
                                    </HasNotAuthorization>
                                </td>
                            </tr>
                            <Authorization requiredRole={ROLE_EMPLOYEE}>
                                <tr>
                                    <td>Process</td>
                                    <td><Link
                                        to={'/process/instance/view/' + task.processInstanceId}>{renderProcessName(task.processName)}</Link>
                                    </td>
                                </tr>
                            </Authorization>
                            <tr>
                                <td>Task</td>
                                <td>{renderTaskName(taskName)}</td>
                            </tr>
                            <tr>
                                <td>State</td>
                                <td>{renderStateName(currentState.name)}</td>
                            </tr>
                            <tr>
                                <td>Responsible</td>
                                <td>{assignedToUser || renderRoleName(role)}
                                    <TaskResponsible
                                        taskReadOnly={taskReadOnly}
                                        task={task}
                                        userId={userId}
                                        isTaskAdmin={isTaskAdmin}
                                        claimTask={claimTask}
                                        unClaimTask={unClaimTask}
                                    />

                                </td>
                            </tr>
                            <ChangeTaskResponsible
                                userWithRoleForTask={userWithRoleForTask}
                                task={task}
                                isTaskAdmin={isTaskAdmin}
                                changeAssignedTo={changeAssignedTo}
                                updateAssignedToUserId={updateAssignedToUserId}
                                taskReadOnly={taskReadOnly}
                            />
                            <tr>
                                <td>Customer</td>
                                <td>{task.customerReference}</td>
                            </tr>
                            {isAppointmentInfoVisible && activeAppointment ?
                                <RenderAppointmentType activeAppointment={activeAppointment}/> : null}
                            </tbody>
                        </table>
                    </Column>
                    <Column size={4}>
                        <table className="process-info-table">
                            <tbody>
                            <tr>
                                <td>Priority</td>
                                <td>{task.priority}</td>
                            </tr>
                            <tr>
                                <td>Task Created</td>
                                <td>{formatDateTime(task.created)}</td>
                            </tr>
                            <tr>
                                <td>Task Due</td>
                                <td>
                                    <Authorization requiredRole={ROLE_TASK_ADMIN}>
                                        <DatePicker
                                            object={task}
                                            name="due"
                                            showTimeSelect={true}
                                            dateFormat="DD.MM.YYYY HH:mm"
                                            placeholder="Due Date"
                                            onChange={changeTaskDueDate}
                                            onBlur={() => {
                                            }}/>
                                    </Authorization>
                                    <HasNotAuthorization requiredRole={ROLE_TASK_ADMIN}>
                                        {formatDateTime(task.due)}
                                    </HasNotAuthorization>
                                </td>
                            </tr>
                            <tr>
                                <td>Task Finished</td>
                                <td>{formatDateTime(task.finished)}</td>
                            </tr>
                            <tr>
                                <td>Finished by</td>
                                <td>{task.finishedByUserName}</td>
                            </tr>
                            <tr>
                                <td>Store</td>
                                <td>{renderStoreName(task.store)}</td>
                            </tr>
                            {isAppointmentInfoVisible && activeAppointment ?
                                <RenderAppointmentReason activeAppointment={activeAppointment}/> : null}
                            </tbody>
                        </table>
                    </Column>
                    <Column size={4}>
                        <table className="process-info-table">
                            <tbody>
                            <tr>
                                <td>{complexity}</td>
                            </tr>
                            <tr>
                                <td>OnyxId</td>
                                <td>{onyxId}</td>
                            </tr>
                            <tr>
                                <td>OnyxServer</td>
                                <td>{onyxServer}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Column>
                </Row>
            </ContentBoxBody>
        </ContentBoxWithoutHeader>
    )
}

const getLatestAppointment = (appointmentList) => {
    return appointmentList.slice(-1)[0];
}

const RenderAppointmentType = ({activeAppointment}) => {
    let mappedAppointmentType = APPOINTMENT_TYPE_LIST.find(appointment => appointment.id === activeAppointment.appointmentType);

    return (
        <tr>
            <td>
                Appointment Type
            </td>
            <td>
                {mappedAppointmentType ? mappedAppointmentType.value : ''}
            </td>
        </tr>
    )
}

const RenderAppointmentReason = ({activeAppointment}) => {
    let mappedAppointmentReason = APPOINTMENT_REASON_LIST.find(appointment => appointment.id === activeAppointment.appointmentReason);

    return (
        <tr>
            <td>
                Appointment Reason
            </td>
            <td>
                {mappedAppointmentReason ? mappedAppointmentReason.value : ''}
            </td>
        </tr>
    )
}

TaskOverviewWidget.propTypes = {
    treatmentPLan: PropTypes.object,
    isPartner: PropTypes.bool.isRequired,
    validateAndTriggerEvent: PropTypes.func.isRequired,
    availableTransitionList: PropTypes.array.isRequired,
    processFlowVisible: PropTypes.bool.isRequired,
    toggleProcessFlowVisibility: PropTypes.func.isRequired,
    currentState: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    role: PropTypes.array,
    changeAssignedTo: PropTypes.func.isRequired,
    updateAssignedToUserId: PropTypes.func.isRequired,
    userWithRoleForTask: PropTypes.array.isRequired,
}

export default TaskOverviewWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TaskOverviewWidget.js